import { render, staticRenderFns } from "./UpcomingDiscussionsCard.vue?vue&type=template&id=25d7d419&scoped=true"
import script from "./UpcomingDiscussionsCard.vue?vue&type=script&lang=ts"
export * from "./UpcomingDiscussionsCard.vue?vue&type=script&lang=ts"
import style0 from "./UpcomingDiscussionsCard.vue?vue&type=style&index=0&id=25d7d419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d7d419",
  null
  
)

export default component.exports